import { useState } from "react";
import { useHistory } from "react-router-dom";

// Import de Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchData } from "../Hooks/useFetchData";

// Import de Navbar
import { UserNavbar } from "../Components/UserNavbar";

// Import de Iconos
import { HiOutlineDocumentText } from "react-icons/hi";
import { FaCheckCircle, FaClock, FaTimesCircle, FaTimes } from "react-icons/fa";

function Movements() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const history = useHistory();

  //User data
  const { user, movements } = useFetchData(accessToken.access_token);

  // Filtro
  const [filtro, setFiltro] = useState("todos");
  const movimientosFiltrados = movements.filter((mov) =>
    filtro === "todos" ? true : mov.mov_type === filtro
  );

  // Modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const openModal = (url) => {
    setSelectedImage(url);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };

  // Modal Motivo de rechazo
  const [modalCommentOpen, setModalCommentOpen] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);
  const openCommentModal = (url) => {
    setSelectedComment(url);
    setModalCommentOpen(true);
  };
  const closeCommentModal = () => {
    setModalCommentOpen(false);
    setSelectedComment(null);
  };

  // Utilidad para mapeo de estados
  const statusMap = {
    V: { icon: <FaCheckCircle />, text: "Verificado" },
    E: { icon: <FaClock />, text: "En espera" },
    R: { icon: <FaTimesCircle />, text: "Rechazado" },
  };

  // Utilidad para mostrar el beneficiario
  const getBeneficiary = (r) =>
    r.mov_type === "Deposito"
      ? `${user?.use_name || ""} ${user?.use_lastName || ""}`
      : r.AccountsBsUser?.accbsUser_owner || "beneficiario";

  // Utilidad para mostrar el monto principal
  const getMainAmount = (r) =>
    r.mov_type === "Deposito"
      ? `${r.mov_currency} ${r.mov_amount}`
      : `${r.mov_oldCurrency} ${r.mov_oldAmount}`;

  const getOtherAmount = (r) =>
    r.mov_type === "Deposito"
      ? "Depósito"
      : `${r.mov_currency} ${r.mov_amount}`;

  return (
    <div className="movements-page">
      <div className="movements-header">
        <h2 className="page-title">Todos los movimientos</h2>
        <p className="page-subtitle">
          Consulta aquí todas tus transacciones realizadas
        </p>

        <div className="filtro-buttons">
          <button
            className={filtro === "todos" ? "active" : ""}
            onClick={() => setFiltro("todos")}
          >
            Todos
          </button>
          <button
            className={filtro === "Deposito" ? "active" : ""}
            onClick={() => setFiltro("Deposito")}
          >
            Recargas
          </button>
          <button
            className={filtro === "Retiro" ? "active" : ""}
            onClick={() => setFiltro("Retiro")}
          >
            Envíos
          </button>
        </div>
      </div>

      <div className="movements-table">
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Beneficiario</th>
                <th>Monto (€)</th>
                <th>Conversión</th>
                <th>Nº Remesa</th>
                <th>Estatus</th>
                <th>Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {movimientosFiltrados.reverse().map((r, idx) => (
                <tr key={idx}>
                  <td>{r.mov_date}</td>
                  <td>
                    <strong>{getBeneficiary(r)}</strong>
                  </td>
                  <td>{getMainAmount(r)}</td>
                  <td>{getOtherAmount(r)}</td>
                  <td>{r.mov_ref}</td>
                  <td>
                    <span className={`status-tag ${r.mov_status}`}>
                      {statusMap[r.mov_status]?.icon}{" "}
                      {statusMap[r.mov_status]?.text}
                    </span>
                  </td>
                  <td>
                    {r.mov_status === "V" && r.mov_img ? (
                      <button
                        className="comprobante-btn"
                        onClick={() =>
                          openModal(`${url}/Movements/image/${r.mov_img}`)
                        }
                      >
                        <HiOutlineDocumentText /> Ver
                      </button>
                    ) : r.mov_status === "R" && r.mov_comment ? (
                      <button
                        className="comprobante-btn"
                        onClick={() =>
                          openCommentModal(`${r.mov_comment}`)
                        }
                      >
                        <HiOutlineDocumentText /> Ver
                      </button>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal de comprobante */}
      {modalOpen && selectedImage && (
        <div className="modal-overlay comprobante-modal">
          <div className="modal-comprobante-mov">
            <button className="close-btn" onClick={closeModal}>
              <FaTimes />
            </button>
            <img src={selectedImage} alt="Comprobante" />
          </div>
        </div>
      )}

      {/* Modal de Motivo de rechazo */}
      {modalCommentOpen && selectedComment && (
        <div
          className="modal-overlay comprobante-modal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-rechazo-mov"
            style={{
              background: "#fff",
              padding: "2rem 2.5rem",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "300px",
              maxWidth: "90vw",
              position: "relative",
            }}
          >
            <button
              className="close-btn"
              onClick={closeCommentModal}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
                color: "#676767",
              }}
            >
              <FaTimes />
            </button>
            <p
              className="rechazo-text"
              style={{
                fontSize: "1.1rem",
                color: "#d32f2f",
                marginTop: "2.5rem",
                marginBottom: "0.5rem",
                wordBreak: "break-word",
              }}
            >
              <strong style={{ color: "#333" }}>Motivo de rechazo:</strong> {selectedComment}
            </p>
          </div>
        </div>
      )}

      <div className="center-btn">
        <button
          className="submit-btn secondary"
          onClick={() => history.push("/Changes")}
        >
          Volver al dashboard
        </button>
      </div>

      <UserNavbar />
    </div>
  );
}

export { Movements };
